import type { Graph3DTheme } from '../core/theme.types';

export const defaultGraph3DTheme: Graph3DTheme = {
  background: '#ffffff',
  node: {
    fill: '#10233f',
    border: '#3b82f6',
    text: '#f8fafc',
    mutedText: '#94a3b8',
    shadow: '#60a5fa',
  },
  edge: {
    color: '#64748b',
    activeColor: '#38bdf8',
  },
  runtime: {
    idle: '#64748b',
    pending: '#a78bfa',
    running: '#38bdf8',
    active: '#22d3ee',
    completed: '#22c55e',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
    candidate: '#f97316',
    disabled: '#475569',
  },
};
